import { computed } from 'vue'
import { buildImageObject } from '~/composables/seo/imageSchemaBuilder'

export function useSettingImageSEO({
    key,
    title,
    description,
    contentUrl,
    thumbnailUrl,
    mainEntityOfPage,
}: {
    key: string
    title: string
    description: string
    contentUrl: string
    thumbnailUrl?: string
    mainEntityOfPage?: string
}) {
    const imageObject = computed(() =>
        buildImageObject({
            name: title,
            description,
            contentUrl,
            thumbnailUrl,
            mainEntityOfPage,
        })
    )

    return useHead(
        computed(() => ({
            script: imageObject.value
                ? [
                    {
                        key,
                        type: 'application/ld+json',
                        innerHTML: JSON.stringify(imageObject.value),
                    },
                ]
                : [],
        }))
    )
}
